import { useState } from "react";
import CryptoJS from "crypto-js";
import { HStack, Pressable, Text, Image } from "native-base";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import Svg from "react-native-svg";
import PopOverModal from "../../../../components/popover";
import {
  logoutSVG,
  partnerMailSVG,
  profileAvatarSVG,
} from "../../../../utils/svg";
import { isLoggedIn } from "../../../../store/reducers/userSlice";
import {
  activeEventTab,
  changeEventStep,
  changeMiceStep,
} from "../../../../store/reducers/eventSlice";
import { userLogoutAPI } from "../../../../api/apis/login";
import { Toaster } from "../../../../components/toaster";
import config from "../../../../utils/config";
import { SSO_LOGOUT_URL } from "../../../../api/url";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import CommonAvatar from "../../../../components/avatar";
import { COLORS } from "../../../../utils/colors";
import DividerLine from "../../../../components/divider";

export const Logout = () => {
  const dispatch = useDispatch();
  const toaster = Toaster();
  const [isOpen, setIsOpen] = useState(false);
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);

  const logoutUser = async () => {
    dispatch(changeEventStep(0));
    dispatch(changeMiceStep(0));
    dispatch(activeEventTab("mice"));

    let res = await userLogoutAPI();
    if (res.error) {
      if (res && res.code && res.code === 401) {
        window.location.reload();
        const microsoftLoginUrl = config.authUrl + SSO_LOGOUT_URL;
        window.location.href = microsoftLoginUrl;
        <Redirect to="/" />;
        dispatch(isLoggedIn(false));
        sessionStorage.clear();
        toaster("Unauthorized", "error", "error");
        return;
      }
      toaster(res.message, "error", "error");
      return;
    } else {
      window.location.reload();
      const microsoftLoginUrl = config.authUrl + SSO_LOGOUT_URL;
      window.location.href = microsoftLoginUrl;
      <Redirect to="/" />;
      dispatch(isLoggedIn(false));
      sessionStorage.clear();
    }
  };

  const onOpenPress = () => {
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const renderProfileImage = () => {
    if (userInfo?.image_url) {
      const imageUrl = userInfo?.image_url?.includes('https') 
        ? userInfo?.image_url 
        : `${config.bucketPath}${userInfo?.image_url}`;
      
      return (
        <Image
          source={{ uri: imageUrl }}
          alt="Profile"
          width="30px"
          height="35px"
          borderRadius="full"
          resizeMode="cover"
          fallbackElement={
            <Svg width="30" height="35" viewBox="0 0 24 28">
              {profileAvatarSVG}
            </Svg>
          }
          onError={() => {
            return (
              <Svg width="30" height="35" viewBox="0 0 24 28">
                {profileAvatarSVG}
              </Svg>
            );
          }}
        />
      );
    }
    return (
      <Svg width="30" height="35" viewBox="0 0 24 28">
        {profileAvatarSVG}
      </Svg>
    );
  };

  return (
    <PopOverModal
      isOpen={isOpen}
      onClose={onClose}
      onOpenPress={onOpenPress}
      svg={renderProfileImage()}
      body={
        <>
          <Text
            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
            mb={1}
          >
            {userInfo?.display_name && userInfo?.display_name !== "nan"
              ? userInfo?.display_name
              : userInfo?.first_name &&
                userInfo?.first_name !== "nan" &&
                userInfo?.first_name}
          </Text>
          {userInfo?.email && (
            <HStack space={2} alignItems={"center"}>
              <CommonAvatar
                width={"30.022px"}
                height={"30px"}
                bgcolor={COLORS.PARTNERS_CARD_COLOR}
                svg={partnerMailSVG}
                svgwh="20"
                view="0 0 20 20"
              />
              <Text
                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
              >
                {userInfo.email}
              </Text>
            </HStack>
          )}
          <DividerLine direction="horizontal" />
          <Pressable onPress={logoutUser} mt={3}>
            <HStack space={2}>
              <Svg width="30" height="35" viewBox="0 0 24 28">
                {logoutSVG}
              </Svg>
              <Text color="#FF0000" mt={1}>
                Logout
              </Text>
            </HStack>
          </Pressable>
        </>
      }
    />
  );
};
